import ContainerFlex, { PrintableBodyWrapper } from "components/ContainerFlex";

import * as St from "./styles";
import { hideCpf, moneyMask } from "utils/mask";
import moment from "moment";
import { getItemLocalStore } from "utils/storeUtils";
import { LOCAL_STORE_CLIENTE } from "../../../../../../constants";
import { useAppSelector } from "redux/app/hooks";
import Endpoints from "services/api/endpoints";
import useApi, { ApiMethod } from "hooks/useApi";
import { useEffect, useState } from "react";
import Spinner from "components/ui/spinner/Spinner";

const PrintPaymentVoucher = (props: any) => {
  const { cpf, nome } = getItemLocalStore(LOCAL_STORE_CLIENTE);
  const {
    cliente: {
      valuePaymentInvoice,
      pinpadResponse,
      invoiceInstallmentCalculation,
    },
  } = useAppSelector((state) => state.cliente);
  const { idPagamento } = props;
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const GetPaymentHour = useApi<{ dataPagamento: string }>(
    Endpoints.pagamentos.getPaymentHour.replace(
      "PARAM_ID_PAGAMENTO",
      idPagamento
    ),
    ApiMethod.GET
  );
  const [dataHora, setDataHora] = useState("");
  const getPaymentHour = async () => {
    setLoading(true);

    const response = await GetPaymentHour.callApi();
    if (response.status !== 200) {
      setError(true);
      setLoading(false);
      return;
    }
    if (response.data?.dataPagamento) {
      setDataHora(
        moment(response?.data?.dataPagamento).format("DD/MM/YYYY HH:mm")
      );
    }
    setLoading(false);
  };

  useEffect(() => {
    getPaymentHour();
    // getPaymentHour vem de useApi/e nao e memoizada; incluir causaria refetch em
    // loop a cada render.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { typeFlow } = useAppSelector((state) => state.security);

  const parcela = Number(pinpadResponse?.installments);

  const valorTotal = Number(pinpadResponse?.totalAmount) / 100;

  const valorParcela =
    typeFlow === "fatura-pagamento-debito"
      ? Number(valuePaymentInvoice)
      : invoiceInstallmentCalculation?.detalhesParcelas[parcela - 1]?.valor;

  const valorTaxaServico =
    typeFlow === "fatura-pagamento-debito"
      ? 0
      : invoiceInstallmentCalculation?.taxaServico;

  const valorTaxaJuros =
    typeFlow === "fatura-pagamento-debito"
      ? 0
      : invoiceInstallmentCalculation?.detalhesParcelas[parcela - 1]
          ?.valorTaxaJuros;

  const taxaJuros =
    typeFlow === "fatura-pagamento-debito"
      ? 0
      : invoiceInstallmentCalculation?.taxaJuros;

  if (loading) {
    return <Spinner loading />;
  }
  if (error) {
    return (
      <St.TitleFaturaTextValue>
        Houve um erro ao gerar o comprovante do pagamento, por favor, procure um
        atendente
      </St.TitleFaturaTextValue>
    );
  }

  return (
    // <PrintableBodyWrapper ref={componentRef}>
    <PrintableBodyWrapper>
      <St.TitleFaturaTextValue>
        Comprovante de Pagamento da Fatura TeuCard
      </St.TitleFaturaTextValue>
      <ContainerFlex row>
        <ContainerFlex>
          <St.SpanTextTitleBold>Cliente:</St.SpanTextTitleBold>
          <St.SpanTextTitle>{nome}</St.SpanTextTitle>
        </ContainerFlex>
        <ContainerFlex end align="flex-end">
          <St.SpanTextTitleBold>CPF:</St.SpanTextTitleBold>
          <St.SpanTextTitle>{hideCpf(cpf)}</St.SpanTextTitle>
        </ContainerFlex>
      </ContainerFlex>
      <St.Dividers />

      <St.TitleFaturaTextValue>Resumo do pagamento</St.TitleFaturaTextValue>
      <ContainerFlex row>
        <St.SpanTextTitle>Data de pagamento:</St.SpanTextTitle>
        <ContainerFlex end align="flex-end">
          <St.SpanTextValue>{dataHora}</St.SpanTextValue>
        </ContainerFlex>
      </ContainerFlex>

      <ContainerFlex row>
        <St.SpanTextTitle>Valor informado:</St.SpanTextTitle>
        <ContainerFlex end align="flex-end">
          <St.SpanTextValue>
            {moneyMask(Number(valuePaymentInvoice))}
          </St.SpanTextValue>
        </ContainerFlex>
      </ContainerFlex>

      <ContainerFlex row>
        <St.SpanTextTitle>{`Taxa de serviço de ${valorTaxaServico}%:`}</St.SpanTextTitle>
        <ContainerFlex end align="flex-end">
          <St.SpanTextValue>
            {moneyMask(invoiceInstallmentCalculation?.valorTaxaServico)}
          </St.SpanTextValue>
        </ContainerFlex>
      </ContainerFlex>

      <ContainerFlex row>
        <St.SpanTextTitle>{`Taxa de juros de ${taxaJuros}%:`}</St.SpanTextTitle>
        <ContainerFlex end align="flex-end">
          <St.SpanTextValue>{moneyMask(valorTaxaJuros)}</St.SpanTextValue>
        </ContainerFlex>
      </ContainerFlex>

      <ContainerFlex row>
        <St.TitleFaturaTextValue>Total de Pagamento:</St.TitleFaturaTextValue>
        <ContainerFlex end align="flex-end">
          <St.SpanTextTitleBold>
            {`(${parcela}x de ${moneyMask(Number(valorParcela))})`}
          </St.SpanTextTitleBold>
        </ContainerFlex>
      </ContainerFlex>
      <St.Dividers />

      <St.TitleFaturaTextValue>Resumo da transação</St.TitleFaturaTextValue>
      <ContainerFlex row>
        <St.SpanTextTitle>Valor transacionado:</St.SpanTextTitle>
        <ContainerFlex end align="flex-end">
          <St.SpanTextValue>{moneyMask(valorTotal)}</St.SpanTextValue>
        </ContainerFlex>
      </ContainerFlex>

      <ContainerFlex row>
        <St.SpanTextTitle>Tipo de Transação:</St.SpanTextTitle>
        <ContainerFlex end align="flex-end">
          <St.SpanTextValue>
            {pinpadResponse?.type === "debit-card" ? "Débito" : "Crédito"}
          </St.SpanTextValue>
        </ContainerFlex>
      </ContainerFlex>

      <ContainerFlex row>
        <St.SpanTextTitle>Cartão:</St.SpanTextTitle>
        <ContainerFlex end align="flex-end">
          <St.SpanTextValue>{pinpadResponse?.cardNumber}</St.SpanTextValue>
        </ContainerFlex>
      </ContainerFlex>

      <ContainerFlex row>
        <St.SpanTextTitle>Bandeira:</St.SpanTextTitle>
        <ContainerFlex end align="flex-end">
          <St.SpanTextValue>{pinpadResponse?.cardBrand}</St.SpanTextValue>
        </ContainerFlex>
      </ContainerFlex>

      <ContainerFlex row>
        <St.SpanTextTitle>Código de autenticação:</St.SpanTextTitle>
        <ContainerFlex end align="flex-end">
          <St.SpanTextValue>{pinpadResponse?.nsu}</St.SpanTextValue>
        </ContainerFlex>
      </ContainerFlex>
      <St.Dividers />
    </PrintableBodyWrapper>
  );
};

export default PrintPaymentVoucher;
